import 'whatwg-fetch'
import { REGISTER_SUCCESS, SIGN_IN_SUCCESS, INIT_AUTH, getAuthToken } from 'modules/auth'
import {
  accountsLoaded,
  accountsLoading,
  getFirstAccount,
  ACCOUNTS_LOADED,
} from 'modules/accounts'
import {
  retrieveBillingInfo,
  saveBillingInfo,
  billingLoading,
  updateCustomerId,
  UPDATE_SUBSCRIPTION,
  RETRIEVE_BILLING_INFO,
  PAYMENT_METHOD_UPDATE,
} from 'modules/subscriptions';
import { loadCounter } from 'modules/counter'
import { API_URL, SUBSCRIPTION_API } from 'config'
import { firebaseDb } from 'modules/firebase'

const loadUserAccounts = uid => {
// fetch all users' account information
  return firebaseDb
    .ref(`users/${uid}/accounts`)
    .once('value')
    .then(snap => {
      const promises = []

      snap.forEach(accountIdSnap => {
        promises.push(firebaseDb
          .ref(`accounts/${accountIdSnap.key}`)
          .once('value'))
      })

      return Promise.all(promises)
        .then(snaps => {
          return snaps.map(snap => ({ ...(snap.val()), key: snap.key }));
        })
    })
}

const createUserAccounts = user => {
  const { displayName, email, uid } = user
  const account = {
    name: displayName || email,
    users: { [uid]: true }
  };
  const accountId = firebaseDb.ref('accounts').push(account).key

  return firebaseDb.ref(`users/${uid}`)
    .set({ accounts: { [accountId]: true } })
    .then(() => ([{ ...account, key: accountId }]))
};

const dispatchLoadingCounter = (dispatch, getState) => {
  const state = getState();
  const account = getFirstAccount(state);
  if (account && account.key) {
    return dispatch(loadCounter(account.key))
  }
};

const dispatchLoadingSubscriptionInfo = (dispatch, getState) => {
  const state = getState()
  const account = getFirstAccount(state)
  if (account && account.key) {
    return dispatch(retrieveBillingInfo(account.key))
  }
};

/**
 * Middleware to load accounts and sites
 * @returns {object} result
 */
export default ({ dispatch, getState }) => next => action => {
  const result = next(action)

  if (typeof action === 'object') {
    if (action.type === REGISTER_SUCCESS) {
      dispatch(accountsLoading(true))
      createUserAccounts(action.payload)
        .then(accounts => dispatch(accountsLoaded(accounts)))
    }
    else if (action.type === SIGN_IN_SUCCESS || (action.type === INIT_AUTH && action.payload && action.payload.uid)) {
      dispatch(accountsLoading(true))
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          'event': 'User Loaded',
          'logged_in': true,
          'userId': action.payload.uid,
          'email': action.payload.email,
          'name': action.payload.displayName || action.payload.email
        })
      }
      loadUserAccounts(action.payload.uid)
        .then(accounts => {
          dispatch(accountsLoaded(accounts))
        })
    }
    else if (action.type === ACCOUNTS_LOADED) {
      dispatchLoadingCounter(dispatch, getState)
      dispatchLoadingSubscriptionInfo(dispatch, getState)
    }
    else if (action.type === RETRIEVE_BILLING_INFO) {
      dispatch(billingLoading(true))
      getAuthToken().then(token => fetch(
        `${SUBSCRIPTION_API}/${action.payload}`,
        {
          method: 'GET',
          mode: 'cors',
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          }
        }
      ))
        .then(response => {
          dispatch(billingLoading(false))
          if (response.ok) {
            return response.json()
          }
          else if (response.status === 404) {
            return { }
          }
          else {
            throw Error(response.statusText)
          }
        })
        .then(response => response.body || {})
        .then(subscription => dispatch(saveBillingInfo(subscription, action.payload)))
        .catch((error) => {
          console.error(error);
          dispatch(billingLoading(false));
        })
    }
    else if (action.type === PAYMENT_METHOD_UPDATE) {
      dispatch(billingLoading(true));
      const account = getFirstAccount(getState());
      getAuthToken().then(token => fetch(
        `${API_URL}/billing/payment-method/${account.key}`,
        {
          method: 'POST',
          body: JSON.stringify(action.payload),
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          }
        }
      ))
        .then(response => response.json())
        .then(response => response.body)
        .then(customer => {
          dispatch(billingLoading(false));
          dispatch(updateCustomerId(customer.id))
        })
        .catch((error) => {
          console.error(error);
          dispatch(billingLoading(false));
        })
    }
    else if (action.type === UPDATE_SUBSCRIPTION) {
      dispatch(billingLoading(true));
      getAuthToken().then(token => fetch(
        `${SUBSCRIPTION_API}/${action.payload.customerId}`,
        {
          method: 'POST',
          body: JSON.stringify(action.payload),
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
          }
        }
      ))
        .then(response => response.json())
        .then(response => response.body)
        .then(subscription => {
          dispatch(billingLoading(false));
          dispatch(saveBillingInfo(subscription, action.payload.customerId));
        })
        .catch((error) => {
          console.error(error);
          dispatch(billingLoading(false));
        })
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/accounts.js